import React from "react"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { TextField, Typography, Box } from "@material-ui/core"
import { type HourReportFormMembershipOption } from "../api/schemas"
import cloneDeep from "lodash/cloneDeep"
import { useTranslation } from "react-i18next"

const sortMembershipOptionsByName = (options: HourReportFormMembershipOption[]) => {
  const cloned = cloneDeep(options)
  return cloned.sort((a, b) => {
    const nameA = a.userFullname.toLowerCase()
    const nameB = b.userFullname.toLowerCase()
    return nameA.localeCompare(nameB)
  })
}

export const MembershipSelector = ({ membershipOptions, selectedMembershipId, onChange }: MembershipSelectorProps) => {
  const { t } = useTranslation("hour-report")
  const selectedOption = membershipOptions.find((option) => option.id === selectedMembershipId)

  const sortedOptions = React.useMemo(() => {
    return sortMembershipOptionsByName(membershipOptions)
  }, [membershipOptions])

  if (!membershipOptions.length) return null

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        {t("form.member", { defaultValue: "Member" })}
      </Typography>
      <Autocomplete
        disableClearable
        options={sortedOptions}
        getOptionLabel={(option) => option.userFullname}
        getOptionSelected={(option, value) => option.id === value.id}
        value={selectedOption}
        onChange={(event, newValue) => onChange(newValue?.id ?? null)}
        renderInput={(params) => <TextField {...params} variant="outlined" margin="dense" fullWidth />}
      />
    </Box>
  )
}

type MembershipSelectorProps = {
  selectedMembershipId: string | null
  onChange: (membershipId: string | null) => void
  membershipOptions: HourReportFormMembershipOption[]
}
